/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'
import {
    type V1SMOptions,
    V1SMOptionsFromJSON,
    V1SMOptionsToJSON
} from '../models/V1SMOptions'
import {
    type V1SMQueryResult,
    V1SMQueryResultFromJSON,
    V1SMQueryResultToJSON
} from '../models/V1SMQueryResult'
import {
    type V1SMSeries,
    V1SMSeriesFromJSON,
    V1SMSeriesToJSON
} from '../models/V1SMSeries'

export interface EmitEventRequest {
    /**
     *
     */
    series: V1SMSeries
    /**
     *
     */
    operation: V1SMOptions
    /**
     *
     */
    eId?: string
    /**
     *
     */
    pId?: string
    /**
     *
     */
    followerId?: string
    /**
     *
     */
    complexityKind?: number
    /**
     *
     */
    coachId?: string
}

export interface QueryEventsRequest {
    /**
     *
     */
    series: V1SMSeries
    /**
     *
     */
    userId?: string
    /**
     *
     */
    operation?: V1SMOptions
    /**
     *
     */
    coachId?: string
    /**
     *
     */
    from?: number
    /**
     *
     */
    to?: number
    /**
     *
     */
    sumBy?: string
    /**
     *
     */
    team?: string
    /**
     *
     */
    pId?: string
    /**
     *
     */
    eId?: string
    /**
     *
     */
    followerId?: string
    /**
     *
     */
    complexityKind?: string
    /**
     *
     */
    step?: string
    /**
     * One total per group over the window ("1d", "7d", "30d" or "90d"; anything else is a 400) ending at `to` (default now). Excludes `from` and `step`. Required to group a rankable series (workouts, plan requests) by userId across users; users who opted out of the leaderboard are left out.
     */
    window?: string
}

/**
 *
 */
export class SmApi extends runtime.BaseAPI {
    /**
     * Creates request options for emitEvent without sending the request
     */
    async emitEventRequestOpts(
        requestParameters: EmitEventRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['series'] == null) {
            throw new runtime.RequiredError(
                'series',
                'Required parameter "series" was null or undefined when calling emitEvent().'
            )
        }

        if (requestParameters['operation'] == null) {
            throw new runtime.RequiredError(
                'operation',
                'Required parameter "operation" was null or undefined when calling emitEvent().'
            )
        }

        const queryParameters: any = {}

        if (requestParameters['operation'] != null) {
            queryParameters['operation'] = requestParameters['operation']
        }

        if (requestParameters['eId'] != null) {
            queryParameters['eId'] = requestParameters['eId']
        }

        if (requestParameters['pId'] != null) {
            queryParameters['pId'] = requestParameters['pId']
        }

        if (requestParameters['followerId'] != null) {
            queryParameters['followerId'] = requestParameters['followerId']
        }

        if (requestParameters['complexityKind'] != null) {
            queryParameters['complexityKind'] =
                requestParameters['complexityKind']
        }

        if (requestParameters['coachId'] != null) {
            queryParameters['coachId'] = requestParameters['coachId']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/sm/{series}`
        urlPath = urlPath.replace(
            '{series}',
            encodeURIComponent(String(requestParameters['series']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     */
    async emitEventRaw(
        requestParameters: EmitEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<void>> {
        const requestOptions =
            await this.emitEventRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.VoidApiResponse(response)
    }

    /**
     */
    async emitEvent(
        requestParameters: EmitEventRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<void> {
        await this.emitEventRaw(requestParameters, initOverrides)
    }

    /**
     * Creates request options for queryEvents without sending the request
     */
    async queryEventsRequestOpts(
        requestParameters: QueryEventsRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['series'] == null) {
            throw new runtime.RequiredError(
                'series',
                'Required parameter "series" was null or undefined when calling queryEvents().'
            )
        }

        const queryParameters: any = {}

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId']
        }

        if (requestParameters['operation'] != null) {
            queryParameters['operation'] = requestParameters['operation']
        }

        if (requestParameters['coachId'] != null) {
            queryParameters['coachId'] = requestParameters['coachId']
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from']
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to']
        }

        if (requestParameters['sumBy'] != null) {
            queryParameters['sumBy'] = requestParameters['sumBy']
        }

        if (requestParameters['team'] != null) {
            queryParameters['team'] = requestParameters['team']
        }

        if (requestParameters['pId'] != null) {
            queryParameters['pId'] = requestParameters['pId']
        }

        if (requestParameters['eId'] != null) {
            queryParameters['eId'] = requestParameters['eId']
        }

        if (requestParameters['followerId'] != null) {
            queryParameters['followerId'] = requestParameters['followerId']
        }

        if (requestParameters['complexityKind'] != null) {
            queryParameters['complexityKind'] =
                requestParameters['complexityKind']
        }

        if (requestParameters['step'] != null) {
            queryParameters['step'] = requestParameters['step']
        }

        if (requestParameters['window'] != null) {
            queryParameters['window'] = requestParameters['window']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/sm/{series}`
        urlPath = urlPath.replace(
            '{series}',
            encodeURIComponent(String(requestParameters['series']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     */
    async queryEventsRaw(
        requestParameters: QueryEventsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1SMQueryResult>> {
        const requestOptions =
            await this.queryEventsRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1SMQueryResultFromJSON(jsonValue)
        )
    }

    /**
     */
    async queryEvents(
        requestParameters: QueryEventsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1SMQueryResult> {
        const response = await this.queryEventsRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }
}
